import type {
  CreateParagraphArgs,
  FooterElement,
  FootersElement,
  FootersElementProps,
} from '../internal';
import { createDefaultParagraph, FooterType } from '../internal';

export function createDefaultFooterByType(
  type: FooterType,
  options: CreateParagraphArgs = {}
): FooterElement {
  return {
    children: [createDefaultParagraph(options)],
    suggestedEdits: [],
    type,
  };
}

interface CreateFootersArgs extends CreateParagraphArgs {
  footersProps?: Partial<FootersElementProps>;
}

export function createDefaultFooters(args: CreateFootersArgs = {}): FootersElement {
  const { footersProps, ...createParagraphArgs } = args;
  return {
    children: [
      createDefaultFooterByType(FooterType.Default, createParagraphArgs),
      createDefaultFooterByType(FooterType.FirstPage, createParagraphArgs),
      createDefaultFooterByType(FooterType.Even, createParagraphArgs),
    ],
    footerMargin: 0.5,
    suggestedEdits: [],
    type: 'footers',
    ...footersProps,
  };
}
